import i18n from 'locales/i18n';
import { useState } from 'react';

const LanguageToggle = () => {
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const toggleLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setCurrentLang(lang);
  };

  return (
    <div className="flex items-center rounded-lg bg-bg-transparent_gray p-1 backdrop-blur-2xl">
      <button
        onClick={() => toggleLanguage('en')}
        className={`${
          currentLang === 'en' ? 'bg-white text-text-primary' : 'bg-transparent text-text-tertiary'
        } w-full rounded-md px-3 py-1 text-body2 transition-all duration-300 ease-in-out`}
      >
        English
      </button>
      <button
        onClick={() => toggleLanguage('ko')}
        className={`${
          currentLang === 'ko' ? 'bg-white text-text-primary' : 'bg-transparent text-text-tertiary'
        } w-full rounded-md px-3  py-1 text-body2 transition-all duration-300 ease-in-out`}
      >
        한국어
      </button>
    </div>
  );
};

export default LanguageToggle;
